export const OPT_TYPE_TO_TITLE_MAP: Record<string, string> = {
  MergeStartYesNoSplitTiles: 'Combine your first Yes/No Split tile with the Start tile',
  MergeChainedChannelSubscriptionTiles: 'Combine linked Subscription Preference tiles',
  MergeChainedMessageSubscriptionTiles: 'Combine linked Subscription Preference tiles',
};
